export const accessControlProvider = {
  can: async ({ resource, action, params }) => {
    let user = localStorage.getItem("user");
    if (user) user = JSON.parse(user);
    else
      return Promise.resolve({
        can: false,
        reason: "Unauthorized",
      });
    // // all access pages
    if (user.role.type == "admin") return { can: true };
    // if (resource == "dashboard" && user.role.type != "authenticated")
    // return Promise.resolve({ can: true });
    // default admin privileges
    let accessArray = params?.resource?.options?.access?.split(" ") || [];
    // check if user has access to the page
    if (accessArray.includes(user.role.name))
      return Promise.resolve({ can: true });
    return Promise.resolve({
      can: false,
      reason: "Unauthorized",
    });
  },
};
